import { createSlice } from '@reduxjs/toolkit';

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    currentIndex: null
  },
  reducers: {
    setCategories: (state, action) => {
      return action.payload; // Set the categories to the payload
    },
    setCurrentIndex: (state, action) => {
        state.currentIndex = action.payload
    }
  },
});

export const { setCategories, setCurrentIndex } = categoriesSlice.actions;
export default categoriesSlice.reducer;